/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-multi-comp */

import { createMedia } from "@artsy/fresnel";
import PropTypes from "prop-types";
import "semantic-ui-css/semantic.css";
import React, { Component } from "react";
// import { MathComponent } from "mathjax-react";
import ReactMarkdown from 'react-markdown'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' 

import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Segment,
  Sidebar,
  Visibility,
} from "semantic-ui-react";

import Abstract from "./Abstract.js";
import SDF from "./Sdf.js";
import ImageResults from "./ImageResults.js";
// import Results from "./Results.js";
// import Comparison from "./Comparison.js";
import overview from "./images/overview.png";
import method from "./images/framework.png";
import audio from "./images/audio.png";
import denoise from "./images/denoise.png";
import edge from "./images/edge.png";
import inpainting from "./images/inpainting.png";
import blur from "./images/blur.png";
import deblur from "./images/deblur.png";
import cls from "./images/cls.png";
// import video_website from "./video/video-website.mp4";

import subsection_style from "./style.js";

const str = `**Theorem 1.** (Group Invariance) Suppose INR $\\Phi: \\mathbb{R}^m \\rightarrow \\mathbb{R}$, then processing operator $\\mathcal{A}\\Phi(x) = \\Pi(\\Phi(x), \\nabla\\Phi(x), \\nabla^2 \\Phi(x), \\cdots)$ satisfies: 1) invariant to shift operator on $\\Phi$ for every $\\Pi$, 2) invariant to rotation operator on $\\Phi$ if $\\Pi(x) = f(\\lVert x \\rVert)$.

**Theorem 2.** (Universal Approximation) Suppose INR $\\Phi: \\mathbb{R}^m \\rightarrow \\mathbb{R}$. For every real-valued function $g: \\mathbb{R}^m \\rightarrow \\mathbb{R}$, there exists a group of coefficients $\\theta_0, \\theta_1, \\cdots \\theta_k, \\cdots$  such that $\\theta_0 \\Phi(x) + \\theta_1^\\top \\nabla\\Phi(x) + \\theta_2^\\top \\nabla^2 \\Phi(x) + \\cdots + \\theta_k^\\top \\nabla^k\\Phi(x) + \\cdots \\approx \\Phi * g$ at any precision.`

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    mobile: 0,
    tablet: 768,
    computer: 1024,
  },
});

/* Heads up!
 * HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled
 * components for such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container fluid>
    {/* <Header
      as="h1"
      content="SinNeRF"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "0.5em" : "1em",
      }}
    /> */}
    <Header
      as="h1"
      // inverted
      textAlign="center"
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1em",
      }}
    >
      <div>
      Signal Processing for Implicit Neural Representations
      </div>
    </Header>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Media greaterThan="mobile">
        <HomepageHeading />
        {children}
      </Media>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Media as={Sidebar.Pushable} at="mobile">
        <HomepageHeading mobile />

        {children}
      </Media>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

const ResponsiveContainer = ({ children }) => (
  /* Heads up!
   * For large applications it may not be best option to put all page into these containers at
   * they will be rendered twice for SSR.
   */
  <MediaContextProvider>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </MediaContextProvider>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

const HomepageLayout = ({ mobile }) => (
  <ResponsiveContainer>
    <div>
      <Container text>
        <Grid
          container
          stackable
          verticalAlign="middle"
          columns={4}
          textAlign="center"
          style={{
            fontSize: "1em",
            fontWeight: "normal",
            marginTop: "0.5em",
            marginBottom: "0.5em",
          }}
        >
          <a href="https://ir1d.github.io/" target="_blank" rel="noreferrer">
            Dejia Xu<sup>1</sup>*
          </a>
          <a
            href="https://peihaowang.github.io/"
            target="_blank"
            rel="noreferrer"
          >
            Peihao Wang<sup>1</sup>*
          </a>
          <a href="https://yifanjiang.net/" target="_blank" rel="noreferrer">
            Yifan Jiang<sup>1</sup>
          </a>
          <a
            href="https://zhiwenfan.github.io/"
            target="_blank"
            rel="noreferrer"
          >
            Zhiwen Fan<sup>1</sup>
          </a>
          <a
            href="https://express.adobe.com/page/CAdrFMJ9QeI2y/"
            target="_blank"
            rel="noreferrer"
          >
            Zhangyang Wang<sup>1</sup>
          </a>
        </Grid>
        <Grid
          container
          stackable
          verticalAlign="middle"
          columns={4}
          textAlign="center"
          style={{
            fontSize: "1em",
            fontWeight: "normal",
          }}
        >
          {/* <a
            href="https://www.humphreyshi.com/"
            target="_blank"
            rel="noreferrer"
          >
            Humphrey Shi<sup>2,3,4</sup>
          </a>
           */}
          <div>
            <sup>1</sup> The University of Texas at Austin
          </div>
          <br />
          <div>*denotes equal contribution</div>
        </Grid>
      </Container>
      <Grid
        container
        stackable
        verticalAlign="middle"
        columns={2}
        width={10}
        textAlign="center"
        style={{
          fontSize: "1.2em",
          fontWeight: "normal",
          marginTop: "0.5em",
          marginBottom: "0.5em",
        }}
      >
        <Grid.Row>
          <Grid.Column columns={2}>
            <Button primary icon>
              <a
                href="https://arxiv.org/abs/2210.08772"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="book" />
                {" Paper"}
              </a>
            </Button>
            <Button primary icon>
              <a
                href="https://github.com/Ir1d/INSP"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "white",
                }}
              >
                <Icon name="github" />
                {" Code"}
              </a>
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Container text>
        <Abstract mobile={mobile} />
        {/* <Header as="h2" textAlign="center" style={subsection_style}>
          Video
        </Header>
        <video
          src={video_website}
          width="100%"
          loop="loop"
          autoplay=""
          controls
        ></video> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
          Method Overview
        </Header>
        <Image src={overview} style={subsection_style}></Image>
        <p>
        Given an INR representing digital
signals, our INSP-Net is capable of direct signal processing without needing to explicitly decode
it. Our model first constructs derivative computation graphs of the original INR and then generates
a linear combination of them into a new INR. It can be later decoded into discretized forms such
as image pixels. The framework is capable of fitting low-level image processing kernels as well as
performing high-level processing such as image classification.
        </p>
        <Image src={method} style={subsection_style}></Image>
        <p>The left image provides an overview of our INSP-Net framework. Each layer combines the
high-order derivative computational graphs of the original INR network. The right image illustrates
the weight sharing scheme in calculating the derivative sub-networks.</p>
<Header as="h2" textAlign="center" style={subsection_style}>
        Theory
        </Header>
    <ReactMarkdown remarkPlugins={[remarkMath]}
    rehypePlugins={[rehypeKatex]}
>{str}</ReactMarkdown>
        {/* <Results />
        <Comparison /> */}
        <Header as="h2" textAlign="center" style={subsection_style}>
        Processing Images
        </Header>
        <ImageResults />
        <SDF></SDF>
        <Header as="h2" textAlign="center" style={subsection_style}>
          Processing Audio
        </Header>
        <Image src={audio} style={subsection_style}></Image>
        <p>We fit the noisy audio with SIREN and train our INSP-Net to process implicitly into a new INR that can be decoded into denoised audio.</p>
        <Header as="h2" textAlign="center" style={subsection_style}>
          Image Classification
        </Header>
        <Image src={cls} style={subsection_style}></Image>
        <Header as="h2" textAlign="center" style={subsection_style}>
          Citation
        </Header>
        <p style={{ paddingBottom: "0.5em", overflow: "auto" }}>
          If our work is helpful for you, please cite:
          <pre>
            <code>
              {`@InProceedings\{Xu_2022_INSP,
    author = \{Xu, Dejia and Wang, Peihao and Jiang, Yifan and Fan, Zhiwen and Wang, Zhangyang\},
    title = \{Signal Processing for Implicit Neural Representations\},
    booktitle={Advances in Neural Information Processing Systems (NeurIPS)},
    year={2022}
\}`}
            </code>
          </pre>
        </p>
      </Container>
    </div>
  </ResponsiveContainer>
);

export default HomepageLayout;
